var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"container"},[_c('div',{staticClass:"d-flex align-center mb-6"},[_c('div',{class:_vm.step !== '가입완료' ? 'active' : 'inactive'},[_vm._v("회원가입")]),_c('v-icon',[_vm._v("mdi-chevron-right")]),_c('div',{class:_vm.step === '가입완료' ? 'active' : 'inactive'},[_vm._v("가입완료")])],1),(_vm.step === '회원가입')?_c('UserInfo',{attrs:{"nextStep":() => {
        _vm.handleStepChange(!_vm.leadId ? '업체정보' : '선택정보');
        _vm.pushDataLayer({
          event: 'clickNextBtn',
          page: 'signup',
          objectSection: 'signupForm',
          objectType: 'button',
          objectId: 'next',
          objectName: '다음',
          step: 1,
        });
      },"step":_vm.step,"form":_vm.form},on:{"update:step":function($event){_vm.step=$event},"update:form":function($event){_vm.form=$event}}}):_vm._e(),(_vm.step === '업체정보')?_c('StoreInfo',{attrs:{"prevStep":() => {
        _vm.handleStepChange('회원가입');
        _vm.pushDataLayer({
          event: 'clickBackBtn',
          page: 'signup',
          objectSection: 'signupForm',
          objectType: 'button',
          objectId: 'back',
          objectName: '이전',
          step: 2,
        });
      },"nextStep":() => {
        _vm.handleStepChange('선택정보');
        _vm.pushDataLayer({
          event: 'clickNextBtn',
          page: 'signup',
          objectSection: 'signupForm',
          objectType: 'button',
          objectId: 'next',
          objectName: '다음',
          step: 2,
        });
      },"step":_vm.step,"form":_vm.form},on:{"update:step":function($event){_vm.step=$event},"update:form":function($event){_vm.form=$event}}}):_vm._e(),(_vm.step === '선택정보')?_c('OptionalInfo',{attrs:{"nextStep":() => _vm.handleStepChange('가입완료'),"step":_vm.step,"form":_vm.form},on:{"update:step":function($event){_vm.step=$event},"update:form":function($event){_vm.form=$event}}}):_vm._e(),(_vm.step === '가입완료')?_c('RegisterDone',{attrs:{"step":_vm.step,"form":_vm.form},on:{"update:step":function($event){_vm.step=$event},"update:form":function($event){_vm.form=$event}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }